import { Box, Grid } from "@mui/material";
import Filter from "../filter";
import Header from "../../components/header";
import DashPortfolio from "../dashPortfolio";
import DashResults from "../dashResults";
import DashFinalized from "../dashFinalized";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useContext } from "react";
import { FilterContext } from "../../contexts/FilterContext";

export default function Initial() {

    const { user } = useContext(AuthContext)
    const { filter,
        report1,
        report2,
        report3,
    } = useContext(FilterContext)

    const dataVisible = (!!report1?.length) || (!!report2?.length) || (!!report3?.length)

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{ justifyContent: "space-between", overflow: "auto", minWidth: "1565px"}}>
                    <Filter />
                </Grid>
                {(user?.id_client == 25886008 ? !!filter?.enterpriseSelected.length
                    : !!user?.id_client) && dataVisible ? (
                    <Grid item xs={12} sx={{ paddingTop: "8px !important", justifyContent: "space-between", overflow: "auto", minWidth: "1565px"  }}>
                        <Header />
                    </Grid>
                ) : null}
            </Grid>

            {(user?.id_client == 25886008 ? !!filter?.enterpriseSelected.length : !!user?.id_client) && dataVisible ? (
                <Box sx={{ width: "100%" }}>
                    <Grid container wrap="nowrap" sx={{ justifyContent: "space-between", overflow: "auto", minWidth: "1550px" }}>
                        {report1?.length ? (<DashPortfolio />) : null}
                        {report3?.length ? (<DashResults />) : null}
                        {report2?.length ? (<DashFinalized />) : null}
                    </Grid>
                </Box>
            ) : null}
        </>
    )
}